/**
 * @generated SignedSource<<f00f1851c89572057f7433acdb642ef5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type imageContent$data = {
  readonly headline: string | null;
  readonly " $fragmentType": "imageContent";
};
export type imageContent$key = {
  readonly " $data"?: imageContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"imageContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "imageContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "b42558437c115636f0419d6e35e0853a";

export default node;
